import React, {
  useState
} from "react";

import {
  useDispatch
} from "react-redux";

import {
  useHistory,
  Link
} from "react-router-dom";

import AuthLayout from "./AuthLayout";
import { forgotPasswordAction } from "../../../store/actions/authActions/authActions";

export default function ForgotPasswordPageNode() {

  const dispatch =
    useDispatch();

  const history =
    useHistory();

  const [email,
    setEmail] =
    useState("");

  const [loading,
    setLoading] =
    useState(false);

  const [error,
    setError] =
    useState("");

  /* =========================
     SEND RESET OTP
  ========================= */

  const handleSubmit =
    async e => {

      e.preventDefault();

      try {

        setLoading(true);

        setError("");

     const  response= await dispatch(

          forgotPasswordAction(
            email
          )
        );


        console.log(response)
        localStorage.setItem(

          "pendingReset",

          email
        );
        localStorage.setItem(

  "resetVerificationId",

  response.verificationId
);

        history.push(
          "/verify-otpV2"
        );

      } catch (error) {

        setError(

  error?.message ||

  "Failed to send OTP"
);
      } finally {

        setLoading(false);
      }
    };

  return (
<AuthLayout

  title="Forgot Password"

  subtitle="Enter your email address and we'll send you a verification code."

>

      
        <form
          onSubmit={
            handleSubmit
          }
        ><div>

    <label>
      First Name
    </label>

          <input
            type="email"
            placeholder="Email Address"
            value={email}
            onChange={e =>
              setEmail(
                e.target.value
              )
            }
            required
          />
</div>
          {

            error && (

              <div
                className="auth-error"
              >

                {error}

              </div>

            )

          }

          <button
           className="auth-btn"
            type="submit"
            disabled={
              loading
            }
          >

          {
  loading
    ? "Sending Verification Code..."
    : "Send Verification Code"
}

          </button>

        </form>

       <div className="auth-footer">

  Remember your password?

  <Link to="/login">

    Sign In

  </Link>

</div>
</AuthLayout>
  );
}